let enableRodeoExpernce = CookieService.getCookie('homePageExperience') === 'rodeo' || urlParams.get('enableRodeoExperience') === 'true';

const showHomePageRodeoExp = () => {
    const heroBannerComponents = document.querySelectorAll('.hero-component')
    const ccSendMoneyEl = document.getElementById('rodeo-experience');
    ccSendMoneyEl && heroBannerComponents?.forEach((comp) => {
        if(comp.getAttribute('id') === 'rodeo-experience') {
            comp.classList.remove('d-none')
        } else {
            comp.classList.add('d-none')
        }
    })
}

(() => {
    try {
        enableRodeoExpernce && showHomePageRodeoExp()
    } catch(e) {
        // Error handled silently for security
    }
})()